module.exports = __webpack_public_path__ + "static/media/dqCitizenshipLogo.fd32720f.png";